import React from 'react';
import { isString, copyMyProps } from './Utils'
import { Modal, Grid, Button } from "semantic-ui-react";
import {func, bool, oneOfType, string, element} from 'prop-types';

class PortletModalHeader extends React.PureComponent {
  static propTypes = {
    onClose: func
  }

  static create(el, rest) {
    if (el === null) {
      return null;
    }
    let myProps = copyMyProps(PortletModalHeader.propTypes)(rest);
    if (isString(el)) {
      return <PortletModalHeader {...myProps}>{el}</PortletModalHeader>
    }
    return React.cloneElement(el, myProps);
  }

  render() {
    let { children } = this.props;
    return (<Modal.Header>
      <Grid>
        <Grid.Column width="11">
          {children}
        </Grid.Column>
        <Grid.Column textAlign="right" floated="right">
          <Button icon="close" basic onClick={this.props.onClose} />
        </Grid.Column>
      </Grid>
    </Modal.Header>);
  }
}

class PortletModal extends React.PureComponent {
  static Header = PortletModalHeader;
  render() {
    let { header, children, ...rest } = this.props;
    return (<Modal {...rest}>
      {PortletModalHeader.create(header, { ...rest })}
      <Modal.Content>
        {children}
      </Modal.Content>
    </Modal>)
  }
}

function linkModal(Component, ModalContent) {
  return class extends React.Component {
    state = {
      modalOpen: false
    }
    static propTypes = {
      editing: bool.isRequired,
      header: oneOfType([string, element])
    }
    handleOpen = () => this.setState({ modalOpen: true })
    handleClose = () => this.setState({ modalOpen: false })
    static selfContained = Component.selfContained;
    static header = Component.header;

    render() {
      let {header, editing} = this.props;
      return ([
        <Component key="widget" openModal={this.handleOpen} />,
        <PortletModal
          header={header}
          key="modal"
          open={this.state.modalOpen && !editing}
          onClose={this.handleClose}>
          <ModalContent />
        </PortletModal>
     ])
    }
  }
}

export default PortletModal;
export { linkModal, PortletModalHeader };